export default __webpack_public_path__ + "static/media/Doubly_List_Insertion_2.3a8a21c1.gif";